/**
 * @Description 组件 室外实时定位
 * @Author
 * @Date 2025/11/4
 */
/* HTML */
<template>
	<div style="height: 100%;width: 100%;position: relative;">

		<!-- 地图 容器 -->
		<div id="mapItemT" style="height: 100%;width: 100%;text-align: left;"></div>

		<div :class="{'aside-button-box': true, 'b-0': !showAsideFlag, 'b-30': showAsideFlag}" style="text-align: end">
			<el-tooltip v-if="true" :content="showAsideFlag ? '关闭轨迹表' : '开启轨迹表'" placement="top">
				<el-button class="aside-button" style="z-index: 9999;position: relative;border-image: none;" :type="showAsideFlag ? 'success' : 'info'" :icon="showAsideFlag ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="changeAsideFlag" round />
				<!--</el-badge>-->
			</el-tooltip>
		</div>

		<!-- 设备表展示myAside -->
		<el-aside v-if="showAsideFlag" id="realtimeLocationMyAsideTable" style="position: absolute;bottom: 0; height: 40%;font-size: 5px;z-index: 1000;width: 100%;overflow-y: auto;">
			<u-table ref="realtimeLocationFilterTable" fixed-columns-roll beautify-table header-drag-style show-body-overflow="tooltip" highlight-current-row :data="trackInfos" size="mini" use-virtual row-id="id" @row-click="handleRowClick" border>
				<u-table-column type="index" :resizable=false align="center" header-align="center" label="序号" width="80px" :border-line=false />
				<u-table-column :resizable=false align="center" header-align="center" :tree-node="true" prop="time" label="上报时间" width="180px" :border-line=false>
					<template slot-scope="scope">
						{{$moment(scope.row.upload_time).format('YYYY-MM-DD HH:mm:ss')}}
					</template>
				</u-table-column>
				<u-table-column :resizable=false align="center" header-align="center" :tree-node="true" prop="positionMode" label="定位模式" width="100px" :border-line=false>
					<template slot-scope="scope">
						{{positionModes[scope.row.position_mode]}}
					</template>
				</u-table-column>
				<u-table-column :resizable=false align="center" header-align="center" :tree-node="true" prop="positionMode" label="GPS经纬度" width="300px" :border-line=false>
					<template slot-scope="scope">
						{{scope.row.lng_gps + "," + scope.row.lat_gps}}
					</template>
				</u-table-column>
				<u-table-column :resizable=false align="center" header-align="center" :tree-node="true" prop="address" label="上报位置" :border-line=false />
			</u-table>

		</el-aside>

	</div>
</template>

/* JS */
<script>
	// 公共变量
	import { mapGPSGaode } from '@/static_dazzle/plugins/amap/map_gps_gaode';

	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 2025/11/4
		 */
		name: "OutdoorTracker",

		/**
		 * @Des 组件注册
		 * @Auth
		 * @Date 2025/11/4
		 */
		components: {}, // components

		/**
		 * @Des 属性值
		 * @Auth
		 * @Date 2025/11/4
		 */
		props: {

		}, // props

		/**
		 * @Des 数据定义
		 * @Auth
		 * @Date 2025/11/4
		 */
		data() {
			return {
				// key list
				key: '',

				// 显示/隐藏 右侧列表
				showAsideFlag: false,
				// 定位方式
				positionModes: {
					1: 'GPS',
					2: 'WIFI',
					3: 'LBS',
					5: 'PHONE',
					6: 'BD',
					7: 'GN'
				}, // positionModes

				// 地图 组件
				mapFn: new mapGPSGaode(),

				// 缓存  记录 轨迹信息
				map_track: new this.HashMap(),
				// 轨迹点 数量
				trackPointsLength: 0,

				// flags
				flags: {
					falg_AMap_inited: false, // flag AMap 已加载
				}, // flags

				// icons
				iocns: {
					start: '/static/images/map/outdoorIocns/icon-point-start.png', // 起始图元
					end: '/static/images/map/outdoorIocns/icon-point-end.png', // 结束图元
					direction: '/static/images/map/outdoorIocns/icon-point-direction.png', // 方向图元
				}, // iocns

				// 查询对象
				trackObj: {},
				// 轨迹集合
				trackInfos: [],

			} // return
		}, // data

		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 2025/11/4
		 */
		created() {

		}, // created

		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 2025/11/4
		 */
		mounted() {
			window.goToHere = this.goToHere;
			// 初始化 地图
			this.initMap();
		}, // mounted

		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 2025/11/4
		 */
		beforeDestroy() {
			// 到这
			window.goToHere = null;
			// 销毁地图
			this.mapFn.destroyMap();
		}, // beforeDestroy

		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 2025/11/4
		 */
		destroyed() {

		}, // destroyed

		/** 缓存组件生命周期 */
		activated() {

		},
		deactivated() {

		},

		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 2025/11/4
		 */
		methods: {

			// 显示/隐藏 右侧列表
			changeAsideFlag() {
				this.showAsideFlag = !this.showAsideFlag;
			},

			/**
			 * @Des 初始化 地图
			 * @Auth
			 * @Date 2025/11/4
			 */
			async initMap() {
				// 地图 组件
				await this.mapFn.initMap('mapItemT', {
					// 地图类型
					mapStyle: 'amap://styles/blue',
				}, (AMap) => {
					// flag AMap 已加载
					this.flags.falg_AMap_inited = true;
					this.$emit("searchTracker");

					// 初始化 地图附属
					this.initMapLayers();
				});
			}, // initMap

			/**
			 * @Des 初始化 地图附属
			 * @Auth
			 * @Date 2025/11/4
			 */
			initMapLayers() {

				// 设置 中心 级别
				// this.mapFn.setZoomAndCenter(10, [117.26235481181146, 36.751024895966464]);

				// 添加 自定义地图
				this.addImageLayer();

				// 查询 组织结构
				// this.searchOrg();

				// 接收轨迹数据
				// this.receiveTrackData({user: this.trackObj, positionList: this.trackInfos});

			}, // initMapLayers

			/**
			 * @Des 添加 自定义地图
			 * @Auth
			 * @Date 2025/11/4
			 */
			addImageLayer() {
				return false;
				// 创建 覆盖物 image
				this.mapFn.creatImageLayer({
					name: '智慧工厂',
					url: '/static/images/map/mapLayers/jg-gongdi-001.png', // 修改为你自己的图片链接
					bounds: [
						[117.261354, 36.751667], // 图片左下角经纬度坐标
						[117.263744, 36.750307] // 图片右上角经纬度坐标，可以根据图片大小调整坐标值
					],
					zIndex: 20, // 设置覆盖物的层级
					opacity: 1, // 设置覆盖物的透明度
				}); // creatImageLayer
			}, // addImageLayer

			/**
			 * @Des 添加 旗帜
			 * @Auth
			 * @Date 2025/11/4
			 */
			// 添加 旗帜
			addFlagMarkers() {
				// 项目
				let projectRow = Object.assign({}, this.organizations[0]);
				// 空值 中止
				if(this.$checkEmpty(projectRow)) return false;

				// 区域
				let areaRows = Object.assign([], projectRow.children);
				Object.assign([], areaRows).forEach((row, index) => {
					// 非区域 跳过
					if(row.level != 2) return true;
					let areaNode = Object.assign({}, row.node);
					// 空值 跳过
					if(this.$checkEmpty(areaNode)) return true;

					// Icon 旗帜
					let flagIcon = this.mapFn.creatIcon({
						size: [60, 60],
						imageSize: [60, 60],
						icon: '/static/images/map/outdoorIocns/iocn-flag.webp'
					});

					let flagDid = ['flagMarker', areaNode.areaId].join('_');
					// Marker 旗帜
					let flagMarker = this.mapFn.creatMarker({
						position: [areaNode.startPointX, areaNode.startPointY], // [117.263698, 36.750353] // 红旗所在的经纬度坐标
						offset: [28, -32], // 将红旗位置上移一些，使其正好位于覆盖物左上角
						icon: flagIcon,
						extData: {
							"markerID": flagDid,
							"markerItem": Object.assign({}, row, {
								did: flagDid
							})
						},
						zIndex: 30, // 设置比覆盖物更高的层级
						clickMarker: this.clickFlagMarker,
						// rightClickMarker: this.rightClickFlag
					});
					// 将标记对象添加到地图上
					this.mapFn.addMarker(flagDid, flagMarker);

				});
			}, // addFlagMarkers
			/**
			 * @Des 点击 旗帜
			 * @Auth
			 * @Date 2025/11/4
			 */
			clickFlagMarker(e) {
				return false;
				e = e || event;
				let extData = e.target.getExtData();

				let markerItem = Object.assign({}, extData.markerItem);
				let areaRow = Object.assign({}, markerItem.node);
				// 空值 中止
				if(this.$checkEmpty(areaRow) || this.$checkEmpty(markerItem.children)) return false;

				// 地图
				let mapRows = Object.assign([], markerItem.children);
				let mapRow = {};
				mapRows.forEach((row, index) => {
					// 已有值 跳过
					if(!this.$checkEmpty(mapRow)) return true;
					// 空值 跳过
					if(this.$checkEmpty(row) || this.$checkEmpty(row.node)) return true;
					mapRows = Object.assign({}, row.node);
				});

				// 路由 跳转
				this.$router.replace({
					path: '/manager/location/monitor',
					query: {
						areaId: areaRow.areaId,
						mapId: mapRow.mapId
					}
				}, () => {}, () => {});
			}, // clickFlagMarker

			/**
			 * @Des 绘制 图元
			 * @Auth
			 * @Date 2025/11/4
			 */
			drawMarker(info) {
				// 创建 marker
				let marker = this.mapFn.creatMarker({
					label: {
						content: info.didName || info.did.substring(info.did.length - 4),
						// content:'手牵手',
						direction: "top",
						offset: [-10, 0],
					},
					offset: [0, 0],
					position: [parseFloat(info.lng_gc), parseFloat(info.lat_gc)],
					icon: !this.$checkEmpty(info.alarms) ? "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png" : "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
					extData: {
						"markerID": info.did,
						"markerItem": info
					},

				});
				marker.content = this.initMarkerContent(info);

				// 添加 marker
				this.mapFn.addMarker(info.did, marker);

			}, // drawMarker
			/**
			 * @Des 移除 图元
			 * @Auth
			 * @Date 2025/11/4
			 */
			removeMarker(did) {
				// 添加 marker
				this.mapFn.removeMarker(did);
			},

			/**
			 * @Des 图元 content
			 * @Auth
			 * @Date 2025/11/4
			 */
			initMarkerContent(item) {
				let alarmHtmls = [];
				Object.assign([], item.alarms).forEach((row, index) => {
					// 空值 跳过
					if(this.$checkEmpty(row) || this.$checkEmpty(row.alarmName) || this.$checkEmpty(row.time)) return true;
					alarmHtmls.push('<span style="color: #2700ff">' + row.alarmName + '  ' + this.$moment(row.time).format('YYYY-MM-DD HH:mm:ss') + '</span>');
				});
				let alarmsHtml = alarmHtmls.length > 0 ? ['<label style="color:#000000"><span style="float: left;">报警信息:</span><p style="color: #2700ff;padding-left: 56px;">', alarmHtmls.join('<br>'), '</p></label></p>'].join('') : '';

				let _content = `
				<div class="map-info-content-box" style="background-color: #fff;font-size: small;border-radius: 10px;opacity: 0.9;padding: 10px;box-shadow: 0px 0px 20px 0px rgba(0,0,0,1);">
					<div style="text-align: center;">
						<h4 style="font-weight: bold; line-height: 30px;color: #000;">` + item.did + `<span style="padding-left: 10px;">( ` + (item.index + 1) + " / " + item.max + ` )</span><button style="padding: 0.1rem 0.5rem;transform: scale(0.8);float: right;" type="button" class="button-custom-1" onclick="goToHere('` + [parseFloat(item.lng_gc), parseFloat(item.lat_gc)] + `','` + item.did + `')"><i class="el-icon-position"></i><span style="padding-left: 5px;">到这</span></button></h4>
					</div>
					<div className="custom-infowindow input-card" style="z-index:999999999999;">
						<label style="color:#000000">气压:  <span style='color: #2700ff'>` + item.air + "帕" + ` </span></label></p>
						<label style="color:#000000">高度:  <span style='color: #2700ff'>` + item.relative_altitude + "米" + `</span></label></p>
						<label style="color:#000000">定位方式：<span style='color: #2700ff'>` + this.positionModes[item.position_mode] + `</span></label></p>
						<label style="color:#000000">剩余电量：<span style='color: #2700ff'>` + item.power + "%" + ` </span></label></p>
						<label style="color:#000000">运行速度：<span style='color: #2700ff'>` + (parseFloat(item.speed) * 3600 / 1000) + ` km/h</span></label></p>
						<label style="color:#000000">地理位置：<span style='color: #2700ff'>` + item.address + ` </span></label></p>
						` + alarmsHtml + `
						<label style="color:#000000">更新时间：<span style='color: #2700ff'>` + this.$moment(item.upload_time).format('YYYY-MM-DD HH:mm:ss') + `</span></label></p>
					</div>
				</div>`;
				
				return _content;
			}, // initMarkerContent
			/**
			 * @Des 图元 title
			 * @Auth
			 * @Date 2025/11/4
			 */
			initMarkerTitle(info) {
				// "电量: " + info.power + "%",
				let title = [
					"轨迹 " + " DID: " + (info.did) + "（" + (info.index + 1) + "/" + (info.max) + "）",
					"气压: " + info.air + " 帕",
					"高度: " + info.relative_altitude + " 米",
					"定位方式: " + this.positionModes[info.position_mode],
					"剩余电量: " + info.power + " %",
					"运行速度: " + (parseFloat(info.speed) * 3600 / 1000),
					"地理位置: " + info.address,
					"更新时间: " + this.$moment(info.upload_time).format('YYYY-MM-DD HH:mm:ss')
				].join('\n');
				return title;
			}, // initMarkerTitle
			/**
			 * @Des 到这
			 * @Auth
			 * @Date 2025/11/4
			 */
			goToHere(lnglat, did) {
				// 地图未加载完成 跳过
				if(!this.flags.falg_AMap_inited) return false;

				this.mapFn.setZoomAndCenter(18, lnglat.split(','));
				this.mapFn.setZoom(20);
			}, // goToHere

			// ======================================================= 解析轨迹 start ======================================================= //
			/**
			 * @Des 接收数据
			 * @Auth
			 * @Date 2025/11/4 
			 */
			receiveTrackData(data) {
				// 轨迹数据
				this.trackInfo = Object.assign({}, data);
				let user = Object.assign({}, data.user);
				let positionList = Object.assign([], data.positionList);

				// 查询对象
				this.trackObj = Object.assign({}, user);
				// 轨迹集合
				this.trackInfos = Object.assign([], positionList);
				if(this.trackInfos.length > 0) {
					this.showAsideFlag = true;
				} else {
					this.showAsideFlag = false;
				}

				let did = user.userId || user.id;
				positionList.forEach((row, index) => {
					row.index = index;
					row.max = positionList.length;
					if(!did) {
						did = row.did || row.tagId;
					}
				});

				// 轨迹点 数量
				this.trackPointsLength = positionList.length;

				// 缓存  记录 轨迹信息
				did && this.trackPointsLength > 0 && this.map_track.put(did, {
					bindingType: 1,
					userName: user.userName,
					no: user.userNo,
					typeId: user.typeId,
					type: (user.typeId ? user.typeId : 1),
					groupId: user.groupId,
					rows: Object.assign([], positionList),
					color: this.mapFn.getColor(), // 获取随机色
					did: did,
					max: positionList.length,
				});

				// 解析数据
				this.analysisTracks();
			}, // receiveTrackData
			/**
			 * @Des 解析数据
			 * @Auth
			 * @Date 2025/11/4 
			 */
			analysisTracks() {
				// 清空地图
				this.mapFn.clearMap();

				if(this.map_track.size() == 0) {
					// 没有轨迹数据
					return;
				}

				let polylines = []; // 记录 polylines
				let markers = []; // 记录 markers
				let massMarkers = []; // 记录 海量点
				var hasNoPoints = true;
				// 根据 开始时间、结束时间 以及 坐标点集合时间范围 进行前后补点
				this.map_track.keySet().forEach((key, n) => {
					var row = this.map_track.get(key);
					// 空值 中止
					if(this.$checkEmpty(row) || this.$checkEmpty(row.rows)) return false;
					row.lineIndex = n;

					// 非空值
					if(hasNoPoints) {
						hasNoPoints = false;
					}

					let startMarker, endMarker;
					let polyPoints = []; // 记录 线段 点
					let rows = row.rows;
					rows.forEach((r, i) => {
						// 起始、结束 角度为0
						if(i == 0 || i == rows.length - 1) {
							r.angle = 0;
						} else {
							let nextRow = Object.assign({}, rows[i + 1]);
							// 计算角度
							let angle = this.mapFn.latLngAngle([nextRow.lat_gc, nextRow.lng_gc], [r.lat_gc, r.lng_gc]);
							r.markerAngle = angle;
						}

						// 记录 线段 点
						polyPoints.push([r.lng_gc, r.lat_gc]);

						// 轨迹点 数量
						if(this.trackPointsLength <= 500) {
							if(i == 0) {
								startMarker = this.creatMarker(Object.assign({}, r));
							} else if(i == rows.length - 1) {
								endMarker = this.creatMarker(Object.assign({}, r));
							} else {
								// 创建图元
								let marker = this.creatMarker(Object.assign({}, r));
								// 记录 markers
								markers.push(marker);
							}
						} else {
							// 轨迹点 > 500 海量点

							// 创建 海量点
							let massMarker = this.creatMassMarker(Object.assign({}, r));
							// 记录 海量点
							massMarkers.push(massMarker);
						}

					});

					// 轨迹点 数量
					if(this.trackPointsLength <= 500) {
						// 记录 markers
						markers.push(startMarker);
						markers.push(endMarker);
					}

					// 创建 polyline
					let polyline = this.mapFn.creatPolyline({
						path: polyPoints,
						showDir: true,
						dirColor: 'pink',
						strokeColor: row.color,
						strokeOpacity: 0.5,
						strokeWeight: 7,
						lineJoin: "round",
						lineCap: "round",
						extData: {
							"polyID": row.did,
							"max": row.max,
							"point": (n + 1),
						},
					});
					// 记录 polylines
					polylines.push(polyline);
				});

				//空值 中止
				if(hasNoPoints) {
					//$('.palyerBox').hide();
					this.$message({
						message: '暂无相关轨迹！',
						type: 'warning',
						showClose: true,
						dangerouslyUseHTMLString: true
					});
					return false;
				}

				// 绘制轨迹线
				this.drawPolylines(polylines);

				// 轨迹点 数量
				if(this.trackPointsLength <= 500) {
					// 绘制轨迹 点
					this.drawMarkers(markers);
				} else {
					// 绘制轨迹 点 海量点
					this.drawMassMarkers(massMarkers)
				}

				// 设置合适视图
				this.mapFn.setFitView();

			}, // analysisTracks
			/**
			 * @Des 绘制轨迹线
			 * @Auth
			 * @Date 2025/11/4 
			 */
			drawPolylines(polylines) {
				// 添加 polylines
				this.mapFn.addPolylines(polylines);
			}, // drawPolylines

			/**
			 * @Des 图元匹配
			 * @Auth
			 * @Date 2025/11/4 
			 */
			matchMarkerIcon(info) {
				// 只有一个点 || 结束点
				if(info.max == 1 || info.index == info.max - 1) {
					return this.mapFn.creatIcon({
						size: [40, 60],
						imageSize: [40, 60],
						icon: this.iocns['end']
					});
				}

				// 起始点
				if(info.index == 0) {
					return this.mapFn.creatIcon({
						size: [40, 60],
						imageSize: [40, 60],
						icon: this.iocns['start']
					});
				}

				// 方向图元
				return this.mapFn.creatIcon({
					size: [32, 32],
					imageSize: [32, 32],
					icon: this.iocns['direction']
				});
			}, // matchMarkerIcon
			/**
			 * @Des 创建图元
			 * @Auth
			 * @Date 2025/11/4 
			 */
			creatMarker(info) {
				// 起始、结束 偏移
				let offset = info.index == 0 || info.index == (info.max - 1) ? [0, -20] : [0, 0];
				// 创建 marker
				let marker = this.mapFn.creatMarker({
					title: this.initMarkerTitle(info),
					offset: offset,
					position: [parseFloat(info.lng_gc), parseFloat(info.lat_gc)],
					icon: this.matchMarkerIcon(Object.assign({}, info)),
					angle: info.markerAngle,
					extData: {
						"markerID": [info.did, info.index].join('_'),
						"markerItem": info
					},
				});
				marker.content = this.initMarkerContent(info);
				return marker;
			}, // creatMarker
			/**
			 * @Des 绘制轨迹 点
			 * @Auth
			 * @Date 2025/11/4 
			 */
			drawMarkers(markers) {
				// 添加 markers
				this.mapFn.addMarkers(markers);
			}, // drawMarkers

			/**
			 * @Des 创建 海量点
			 * @Auth
			 * @Date 2025/11/4 
			 */
			creatMassMarker(info) {
				// 创建 marker
				let massMarker = this.mapFn.creatMassMarker({
					lnglat: [info.lng_gc, info.lat_gc],
					title: this.initMarkerTitle(info),
					markerID: [info.did, info.index].join('_'),
					uploadTime: this.$moment(info.upload_time).format('YYYY-MM-DD HH:mm:ss'),
					point: (info.index + 1) + "/" + (info.max),
					extData: {
						"markerID": [info.did, info.index].join('_'),
						"markerItem": info
					},
					myContent: this.initMarkerContent(info)
				});
				return massMarker;
			}, // creatMassMarker
			/**
			 * @Des 绘制轨迹 点 海量点
			 * @Auth
			 * @Date 2025/11/4 
			 */
			drawMassMarkers(massMarkers) {
				// 创建海量点
				this.mapFn.creatMassMarks(massMarkers);
			}, // drawMarkers
			// ======================================================= 解析轨迹 end ======================================================= //

			handleRowClick(row) {
				this.mapFn.infoWindowDid = row.upload_time;
				let infoContent = this.initMarkerContent(row);
				// 更新内容
				this.mapFn.updateInfoWindow(row.upload_time, infoContent);
				let position = this.mapFn.creatPosition(row.lng_gc, row.lat_gc);
				// 设置中心位置
				this.mapFn.openInfoWindow(position);
			}

		}, // methods

		/**
		 * @Des 监听
		 * @Auth
		 * @Date 2025/11/4
		 */
		watch: {

		}, // watch

		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 2025/11/4
		 */
		computed: {

		}, // computed

	} // export default
</script>

/* CSS */
<style lang="scss" scoped>
	.el-button--success {
		background-color: #67C23A;
		border-color: #67C23A;
	}
	
	.el-button--primary {
		background-color: #409EFF;
		border-color: #409EFF;
	}
	
	.el-button--info {
		background-color: #909399;
		border-color: #909399;
	}
	
	.el-button--danger {
		background-color: #F56C6C;
		border-color: #F56C6C;
	}
	
	.aside-button-box {
		width: 70px;
		height: 40px;
		position: absolute;
		bottom: 0;
		margin: auto;
		&.b-0 {
			left: calc(50% - 20px);
			bottom: 0;
		}
		&.b-30 {
			left: calc(50% - 20px);
			bottom: calc(40% - 20px);
		}
	}
	
	/deep/ .beautifyTableClass {
		height: 100%;
		.el-table {
			height: 100%;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
		}
		.el-table th>.cell {
			height: 40px;
			line-height: 40px;
		}
		.el-input__inner {
			height: 35px;
			border-color: #ccc;
			background-color: #fff;
			color: #000;
		}
		.el-table__empty-block {
			background-color: #eee;
			color: #ccc;
		}
	}
</style>

/* CSS */
<style lang="scss">
	.buttonnn {
		display: inline-block;
		padding: 0.5em 1.5em;
		background-color: #1600ff78;
		//background-color: transparent;
		color: #fff;
		border-radius: 30px;
		border: none;
		cursor: pointer;
		position: relative;
		box-shadow: 0 2px 25px rgba(233, 30, 99, 0.5);
		outline: 0;
		transition: transform ease-in 0.1s, background-color ease-in 0.1s, box-shadow ease-in 0.25s;
	}
	/*.buttonnn:hover::before {
  position: absolute;
  content: '';
  left: -2em;
  right: -2em;
  top: -2em;
  bottom: -2em;
  pointer-events: none;
  transition: ease-in-out 1s;
  background-repeat: no-repeat;
  background-image: radial-gradient(circle, #a6ff00 20%, transparent 20%),
  radial-gradient(circle, #00e1ff 20%, transparent 20%),
  radial-gradient(circle, #00ffa6 20%, transparent 20%),
  radial-gradient(circle, #ffd500 20%, transparent 20%),
  radial-gradient(circle, #ff0000 20%, transparent 20%),
  radial-gradient(circle, #2fff00 20%, transparent 20%),
  radial-gradient(circle, #ffaa00 20%, transparent 20%),
  radial-gradient(circle, #44ff00 20%, transparent 20%),
  radial-gradient(circle, #c1a3af 20%, transparent 20%),
  radial-gradient(circle, #db6776 20%, transparent 20%),
  radial-gradient(circle, #80ff00 20%, transparent 20%),
  radial-gradient(circle, #ff00c8 20%, transparent 20%),
  radial-gradient(circle, #ff0000 20%, transparent 20%),
  radial-gradient(circle, #6aff00 20%, transparent 20%),
  radial-gradient(circle, #ff0081 20%, transparent 20%),
  radial-gradient(circle, #ff0081 20%, transparent 20%),
  radial-gradient(circle, #00ffff 20%, transparent 20%),
  radial-gradient(circle, #b3ff00 20%, transparent 20%),
  radial-gradient(circle, #ff3300 20%, transparent 20%),
  radial-gradient(circle, #2b2b2b 20%, transparent 20%),
  radial-gradient(circle, #c4bec2 20%, transparent 20%),
  radial-gradient(circle, #bd195e 20%, transparent 20%),
  radial-gradient(circle, #c7779e 20%, transparent 20%),
  radial-gradient(circle, #ac7474 20%, transparent 20%);
  background-size: 10% 10%, 20% 20%, 15% 15%, 20% 20%, 18% 18%, 10% 10%, 15% 15%, 10% 10%, 18% 18%,
  15% 15%, 20% 20%, 18% 18%, 20% 20%, 15% 15%, 10% 10%, 20% 20%;
  background-position: 18% 40%, 20% 31%, 30% 30%, 40% 30%, 50% 30%, 57% 30%, 65% 30%, 80% 32%, 15% 60%,
  83% 60%, 18% 70%, 25% 70%, 41% 70%, 50% 70%, 64% 70%, 80% 71%;
  animation: bubbles ease-in-out 0.75s forwards;
}*/
	
	.buttonnn:hover {
		/*transform: scale(0.95);*/
		background-color: #f3037c;
		box-shadow: 0 2px 25px rgba(233, 30, 99, 0.5);
	}
	
	.buttonnn::before {
		animation: none;
		background-size: 0;
	}
	
	@keyframes bubbles {
		0% {
			background-position: 18% 40%, 20% 31%, 30% 30%, 40% 30%, 50% 30%, 57% 30%, 65% 30%, 80% 32%, 15% 60%, 83% 60%, 18% 70%, 25% 70%, 41% 70%, 50% 70%, 64% 70%, 80% 71%;
		}
		50% {
			background-position: 10% 44%, 0% 20%, 15% 5%, 30% 0%, 42% 0%, 62% -2%, 75% 0%, 95% -2%, 0% 80%, 95% 55%, 7% 100%, 24% 100%, 41% 100%, 55% 95%, 68% 96%, 95% 100%;
		}
		100% {
			background-position: 5% 44%, -5% 20%, 7% 5%, 23% 0%, 37% 0, 58% -2%, 80% 0%, 100% -2%, -5% 80%, 100% 55%, 2% 100%, 23% 100%, 42% 100%, 60% 95%, 70% 96%, 100% 100%;
			background-size: 0% 0%;
		}
	}
	
	.el-popover {
		border-radius: 30px !important;
	}
	
	.btnn {
		position: relative;
		width: 7rem;
		//left: 3.6rem;
		margin: 5px 5px 0 0;
	}
	
	.amap-icon img {
		display: block;
	}
	
	.amap-marker-label {
		color: #000;
		font-size: 16px;
	}
	
	.amap-info-content {
		font-size: 12px;
		border-radius: 30px;
	}
	
	.amap-controlbar .amap-luopan {
		width: 92px;
		height: 0px;
		background: url(https://webapi.amap.com/theme/v1.3/controlbar/ctb.png) -22px -30px no-repeat;
		background-size: 348px 270px;
		user-select: none;
	}
	
	.amap-info-content {
		opacity: 0.9 !important;
		padding: 1vh 1vh 1vh 1vh !important;
	}
	
	.amap-info-close {
		display: none !important;
	}
	
	.amap-icon img,
	.amap-marker-content img {
		width: 25px;
		height: 34px;
	}
	
	.amap-marker-label {
		top: -23px !important;
		left: -5px !important;
		border: 1px solid transparent !important;
		background-color: rgba(0, 0, 0, 0) !important;
		font-weight: bold !important;
		color: rgba(68, 0, 255, 0.99);
	}
	
	.amap-ctrl-list-layer {
		position: absolute !important;
		/*top: 9vh !important;*/
		/*right: 0 !important;*/
		overflow: hidden !important;
		z-index: 1 !important;
		color: #000;
	}
	
	.amap-info-content {
		border-radius: 30px;
		position: relative;
		background: #fff;
		padding: 10px 18px 10px 10px;
		line-height: 1.4;
		overflow: auto;
	}
	/*隐藏地图Logo*/
	
	.amap-logo {
		display: none;
		visibility: hidden
	}
	
	.amap-copyright {
		/*right: 70px !important;*/
		/*left: auto !important;*/
		visibility: hidden
	}
	/* 比例尺控件字体颜色 */
	
	.amap-scalecontrol {
		background-color: #66b1ff;
	}
</style>


// WEBPACK FOOTER //
// src/components_outdoor/Outdoor/OutdoorTracker.vue